<div class="raw main">
    <div class="col-12">
        <div class="col-8 signtime">
            <div class="signup animated fadeIn" *ngIf="EventData">
                <h1>報名時段選擇
                    <ng-container *ngIf="IsMobile">
                        <div class="more" (click)="ToggleCard()">顯示目前報名買主</div>
                    </ng-container>
                </h1>
    
                <style>
                        .swiper-container {
                            width: 100%;
                            height: 100%;
                            }
    
                            .swiper-slide {
                            text-align: center;
                            font-size: 18px;
                            background: #fff;
    
                            /* Center slide text vertically */
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: -webkit-flex;
                            display: flex;
                            -webkit-box-pack: center;
                            -ms-flex-pack: center;
                            -webkit-justify-content: center;
                            justify-content: center;
                            -webkit-box-align: center;
                            -ms-flex-align: center;
                            -webkit-align-items: center;
                            align-items: center;
                         }
                </style>
                <div class="timeArea">
                    <div class="swiper-container" id="timearea">
                        <div class="swiper-wrapper">
                        <ng-container *ngFor="let g of Data.sessions_group;let _index = index;">
                            <div class="swiper-slide {{_index == nowGroupIndex ? 'active' : ''}}" (click)="SetGroup(_index)">{{g.date}}</div>
                        </ng-container>
                        </div>
                    </div>
                    <div class="note" id="myTip">如何報名<i class="icon icon-info">&#xe803;</i></div>
                    <div style="display: none;">
                        <div id="template_how">
                            <div class="howinfo">
                                <label>點選時段，填寫報名表，報名資料將送買主篩選並決定洽談會時段，本會將另通知獲選廠商正式洽談時段。報名程序如下：</label>
                                <img src="../assets/images/left4.png"/>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="timePoint">

                    <ng-container *ngIf="morning.length > 0">
                        <label>上午</label>
                        <div class="period">
                            <ng-container *ngFor="let t of morning;">
                                <span class="{{(selectedTimeID == t.session_id) ? 'active' : ''}} {{(t.available) ? '' : 'disabled'}}" (click)="TimeSelect(t)">
                                    {{t.sessionTime.start | time}}~{{t.sessionTime.end | time}}
                                </span>
                            </ng-container>
                        </div>
                    </ng-container>
                    
                    <ng-container *ngIf="afternoon.length > 0">
                        <label>下午</label>
                        <div class="period">
                            <ng-container *ngFor="let t of afternoon;">
                                <span class="{{(selectedTimeID == t.session_id) ? 'active' : ''}} {{(t.available) ? '' : 'disabled'}}" (click)="TimeSelect(t)">
                                    {{t.sessionTime.start | time}}~{{t.sessionTime.end | time}}
                                </span>
                            </ng-container>
                        </div>
                    </ng-container>
                    
                    <ng-container *ngIf="canSignUp == true && SignUpMsg != ''">
                        <label style="font-weight: normal;" [innerHtml]="SignUpMsg">{{SignUpMsg}}</label>
                    </ng-container>

                    <ng-container *ngIf="canSignUp == false">
                        <label style="font-weight: normal;" [innerHtml]="SignUpMsg"></label>
                    </ng-container>

                    <ng-container *ngIf="canSignUp">
                         <div class="btn" style="margin-top: 2rem;" (click)="GoCheck()">{{btnTxt}}</div>
                    </ng-container>

                    <ng-container *ngIf="canSignUp == false && btnTxt != ''">
                        <div class="btn disabled" style="margin-top: 2rem;">{{btnTxt}}</div>
                    </ng-container>

                </div>
                
            </div>
            
            
            <div class="sideCard {{IsShow ? 'active' : ''}}" *ngIf="EventData">
                <div class="col-4 side">
                    <label>您正在報名⋯</label>
                    <ng-container *ngIf="IsMobile">
                        <div class="close" (click)="ToggleCard()">
                            <i class="icon icon-close">&#xe802;</i>
                        </div>
                    </ng-container>
                    <h1>{{Data.company_name}}</h1>
                    <div class="item">
                        <label>國別</label>
                        <p>{{Data.country.name}}({{Data.country.continental}})</p>
                    </div>
                    <div class="item" *ngIf="Data.company_url">
                        <label>公司網址</label>
                        <p><a href="{{Data.company_url}}" target="_blank">{{Data.company_url}}</a></p>
                    </div>
                    <div class="item">
                        <label>營業項目</label>
                        <p>{{Data.business_items}}</p>
                    </div>
                    <div class="item">
                        <label>採購產品</label>
                        <div class="tags hoverEvt">
                            <ng-container *ngFor="let prod of Data.products">
                                <span [attr.data-desc]="prod.description" 
                                    [attr.data-spec]="prod.spec_visible"
                                    [attr.data-attach]="prod.hasAttachment"
                                    [attr.data-pid]="prod.id"
                                    [attr.data-buyer]="Data.buyer_id">{{prod.name}}</span>
                            </ng-container>
                        </div>
                    </div>
                    <div class="item" *ngIf="Data.displayMemo">
                        <label>備註</label>
                        <p>{{Data.memo}}</p>
                    </div>
                    <hr/>
                    <div class="relative">
                        <div class="title">
                            <label>所屬採購案</label>
                            <span *ngIf="EventData.leftAppointmentCount > 0">此活動尚可預約 {{EventData.leftAppointmentCount}} 次</span>
                        </div>
                        <h2>{{EventData.name}}</h2>
                        <p class="time">
                            <i class="icon icon-clock">&#xe80d;</i>{{EventData.eventFullDateTime}}
                        </p>
                        <p class="addr">
                            <i class="icon icon-web">&#xe805;</i>{{EventData.location}} 
                            <a *ngIf="EventMap != ''" href="{{EventMap}}" target="_blank">
                                <span class="map"><i class="icon icon-map">&#xe804;</i>地圖</span>
                            </a>
                        </p>
    
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
